import { render } from "./TableFormPoints.vue?vue&type=template&id=e9c71162&scoped=true"
import script from "./TableFormPoints.vue?vue&type=script&lang=js"
export * from "./TableFormPoints.vue?vue&type=script&lang=js"

import "./TableFormPoints.vue?vue&type=style&index=0&id=e9c71162&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9c71162"]])

export default __exports__